module.exports = __webpack_public_path__ + "static/img/s.b7908295.png";